import { render, staticRenderFns } from "./AllTab.vue?vue&type=template&id=71261d6c&scoped=true&"
import script from "./AllTab.vue?vue&type=script&lang=js&"
export * from "./AllTab.vue?vue&type=script&lang=js&"
import style0 from "./AllTab.vue?vue&type=style&index=0&id=71261d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71261d6c",
  null
  
)

export default component.exports